import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import styled from '@emotion/styled';
import { animationSpeed } from '../../constants.js';
import { validFocusStyle } from '../../styles/focusStyles.js';
import { a } from '../../styles/textStyles.js';
import { Box } from '../Box/Box.js';
import { fontWeightToValue } from '../../styles/fontStyles.js';

const BaseLinkStyle = {
    ...a,
    textDecorationColor: "transparent",
    transition: `ease all ${animationSpeed.fast}`,
    textDecorationThickness: 2,
    "&:hover": {
        textDecorationThickness: 2,
        textDecorationColor: "unset"
    },
    "&:focus-visible": {
        ...validFocusStyle,
        outline: "none"
    }
};
const TextLink = styled(Box)(BaseLinkStyle).withComponent("a");
const TextLinkButtonBase = styled(Box)({
    ...BaseLinkStyle,
    fontVariationSettings: `"wght" ${fontWeightToValue.medium}`
}).withComponent("button");
const TextLinkButton = /*#__PURE__*/ React.forwardRef((props, ref)=>jsx(TextLinkButtonBase, {
        ref: ref,
        type: "button",
        ...props
    }));

export { BaseLinkStyle, TextLink, TextLinkButton };
